export const getNavigationOpened = (state) => state.navigation.navigationOpened